import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { GetAgreementUrlResponse, DownloadAgreementUrlResponse } from '../models/agreement';

// contract link after select plan
let contractLink = '';
export const getContractStringLink = () => contractLink;
export const setContractStringLink = (value: string) => {
	contractLink = value;
};

export const getContractUrlRequest = async () => {
	try {
		const response = await axios.get<JsonResponse<GetAgreementUrlResponse>>('register/get-platform-use-contract');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const downloadContractUrlRequest = async () => {
	try {
		const response = await axios.put<JsonResponse<DownloadAgreementUrlResponse>>('register/download-platform-use-contract');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
